<div class="sm-px-2 sm-py-6">
  <div class="sm-px-8 sm-flex sm-flex-col sm-gap-4 sm-items-center">
    <h1 class="sm-font-bold sm-text-xl sm-leading-8 sm-text-center" i18n>Upload CSV</h1>
    <p class="sm-leading-5 sm-font-normal" i18n>Uploading CSV to Dashpivot, this may take a few minutes...</p>
    <cc-progress-bar
      [percentageProgress]="progress"
      (barCompleted$)="onProgressBarFull()"
    ></cc-progress-bar>
  </div>
</div>
